export default {
      id: "copy-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#copy",
      toString: function () {
        return this.url;
      }
    }